import script from "./assets_component.vue?vue&type=script&setup=true&lang=js"
export * from "./assets_component.vue?vue&type=script&setup=true&lang=js"

import "./assets_component.vue?vue&type=style&index=0&id=7bd16b58&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bd16b58"]])

export default __exports__